import styled from 'styled-components';
import { Typography, Box } from '@mui/material';

import LoadingPage from '../../../../../../components/LoadingPage';
import LabelCheckbox from '../../../../../components/LabelCheckbox';

const StyledLoadingPage = styled(LoadingPage)`
  height: 100px;
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px;
  row-gap: 15px;
`;

const SubContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const StyledCheckbox = styled(LabelCheckbox)`
  height: 35px;
`;

const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;

  row-gap: 10px;
  margin-bottom: 10px;
`;

const ContentText = styled(Typography)`
  font-size: 12px;
`;

const ContentSubText = styled(Typography)`
  font-size: 12px;
  margin-left: 15px;
`;

const SubtitleText = styled(Typography)`
  font-size: 14px;
  font-weight: 600;
  color: #000000;
  margin-top: 10px;
  margin-bottom: 10px;
`;

const StyledProgressBox = styled(Box)`
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 16px;
  background-color: #fafafa;
  margin-bottom: 10px;
`;

export {
  StyledLoadingPage,
  Container,
  SubContainer,
  StyledCheckbox,
  ContentContainer,
  ContentText,
  SubtitleText,
  StyledProgressBox,
  ContentSubText,
};
